import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import {Location} from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FirmaRevisionService } from 'src/app/services/firma_revision/firma-revision.service';
import { GenericService } from 'src/app/services/generic/generic.service';
import { ConfirmationService } from 'primeng/api';


@Component({
  selector: 'app-grupo-botones',
  templateUrl: './grupo-botones.component.html',
  styleUrls: ['./grupo-botones.component.css']
})
export class GrupoBotonesComponent implements OnInit {

  @Input() id: string = '';
  @Input() database: string = '';
  @Input() data: any = [];
  @Input() showDuplicate: boolean;
  @Input() showInfo: boolean;
  @Input() showDelete: boolean = true;
  @Input() showEdit: boolean = true;
  @Output() infoChild: EventEmitter<any> = new EventEmitter<any>();
  @Output() editChild: EventEmitter<any> = new EventEmitter<any>();
  @Output() deleteChild: EventEmitter<any> = new EventEmitter<any>();
  @Output() duplicateChild: EventEmitter<any> = new EventEmitter<any>();
  
 

  constructor(
    private router: Router,
    private location: Location,
    private FirmaRevisionService: FirmaRevisionService,
    private route:ActivatedRoute,
    private genericService: GenericService,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit() {
  }

  infoMethodChild() {
    this.infoChild.emit(this.data);
  }

  editMethodChild() {

    this.editChild.emit(this.data.id);
  }

  deleteMethodChild() {
    this.deleteChild.emit(this.data.id);
  }
  
  duplicateMethodChild() {
    this.duplicateChild.emit(this.data);
  }



  checkRole() {
    try {
      if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0 ) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
     
  }
  checkRevisionTirita() {
    if (localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0) {
      return true;
    }
    let readonly = '';
    try {
      readonly = localStorage.getItem('readonly');
    } catch (error) {
      readonly = '';
    }
    if ( readonly.localeCompare('1') == 0 ){
      return false;
    } else {
      return true;
    }
  }
  checkRevisionButtonsCancel( ) {
    try {
      if ( localStorage.getItem('readonly').localeCompare('1') == 0 ){
        return false;
      }
    } catch (error) {
      
    }
   
  
    if ( this.data == null || this.data == undefined ) {
      return false;
    } 
    if ( this.data.length > 1 ) {
      return true;
    } 
  }
  checkRevisionButtons( ) {
    try {
      if ( localStorage.getItem('readonly').localeCompare('1') == 0 ){
        return false;
      }
    } catch (error) {
      
    }
   
    if ( localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0 ){
      return true;
    }
    if ( this.data.revision == null || this.data.revision == undefined ) {
      return true;
    } 

    if ( this.data.revision.localeCompare('-') == 0) { 
      return false;
    }
    if ( this.data.revision.length > 1 ) {
      
      return false;
    } else {
      return true;
    }
  }
  checkRevision() {
    try {
      if ( this.data == null || this.data == undefined ) {
        return false;
      } else {
        if ( (this.data.revision ).length > 1 ) { 
          return true;
        } else {
          return false;
        }
       
      }
    } catch (error) {
      return false;
    }
     
  }
  
  changeValueRevision( ) {
  
    //console.log('data.revision',data.revision);
      
    try {
     
      if (this.data.revision == null || this.data.revision == undefined || this.data.revision.length == 0 ) {
        //console.log(data, this.database);
        let revision = JSON.parse(localStorage.getItem('calidad_user_tag_1'));
        //console.log(revision);
        
        let firma = {
          revision: revision.name,
          id: this.data.id,
          database: this.database 
        }
        this.FirmaRevisionService.updateFirma( firma).toPromise()
        .then( resp => {
          //console.log( 'firma', resp );
         
        }).catch ( error => {
          console.log(' error', error );
          
        });
      } else {
        let firma = {
          revision: '',
          id: this.data.id,
          database: this.database 
        }
        this.FirmaRevisionService.updateFirma( firma).toPromise()
        .then( resp => {
          //console.log( 'firma', resp );
          
        }).catch ( error => {
          console.log(' error', error );
          
        });
      }
    } catch (error) {
      let firma = {
        revision: '',
        id: this.data.id,
        database: this.database 
      }
      this.FirmaRevisionService.updateFirma( firma).toPromise()
      .then( resp => {
        //console.log( 'firma', resp );
      
      }).catch ( error => {
        console.log(' error', error );
        
      });
    }

    
  }
  
  checkRevisionandRole(value) {
    try {
      if ( value == null || value == undefined ) {
        return false;
      } else {
        if ( (value as string).length > 1 ) {
          if( localStorage.getItem('role') == null) { 
            return false;
          } 
          if( localStorage.getItem('role').localeCompare('ROLE_ADMIN') == 0 ) { 
            return false;
          } 
          return true;
        } else {
          return false;
        }
       
      }
    } catch (error) {
      return false;
    }
     
  }
  delete(id) {
    
    this.confirmationService.confirm({
      header:'Confirmación',
      acceptLabel:'Aceptar',
      rejectLabel:'Cancelar',
      message: 'Quieres eliminar este registro?',
      accept: () => {
        
        this.genericService.delete(id, this.database).subscribe(data=>{
           // console.log("Ha ido bien",data);
            

        },error=>{
          console.error("error ",error);
        });
      }
  });
 
}

nuevoControl(){
  this.router.navigate(['crear'],{relativeTo:this.route});
}

}
